'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { motion, useReducedMotion } from 'framer-motion';
import { Badge } from '@/components/ui/badge';
import { useCadrinoCopy } from '@/lib/cadrino-landing/useCadrinoCopy';
import { getZkEventTypeBadgeClassName } from '@/lib/zk-attendance-event-types';
import { DashboardChrome } from './product/ProductMocks';
import { cn } from '@/lib/utils';
export function HeroProductPreview() {
  const $ = _c(60);
  const c = useCadrinoCopy();
  const p = c.hero.preview;
  const reducedMotion = useReducedMotion();
  let t0;
  if ($[0] !== reducedMotion) {
    t0 = reducedMotion ? undefined : {
      y: -6,
      scale: 1.005
    };
    $[0] = reducedMotion;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== reducedMotion) {
    t1 = reducedMotion ? undefined : {
      duration: 0.22,
      ease: "easeOut"
    };
    $[2] = reducedMotion;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = p.windowTitle;
  let t3;
  if ($[4] !== p.badge) {
    t3 = <p className="text-[10px] font-medium uppercase tracking-wider text-blue-600">{p.badge}</p>;
    $[4] = p.badge;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== p.title) {
    t4 = <p className="text-sm font-semibold text-gray-900">{p.title}</p>;
    $[6] = p.title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div>{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="relative flex h-1.5 w-1.5"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-500 opacity-50" /><span className="relative h-1.5 w-1.5 rounded-full bg-green-600" /></span>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== p.live) {
    t7 = <div className="flex shrink-0 items-center gap-1.5 rounded-md border border-green-200 bg-green-50 px-2 py-1">{t6}<span className="text-[10px] font-medium text-green-800">{p.live}</span></div>;
    $[12] = p.live;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <div className="border-b border-gray-100 px-4 py-3 sm:px-5"><div className="flex items-start justify-between gap-2">{t5}{t7}</div></div>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== p.metrics) {
    t9 = p.metrics.map(_temp);
    $[17] = p.metrics;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <div className="grid grid-cols-3 gap-2 border-b border-gray-100 px-4 py-3 sm:px-5">{t9}</div>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== p.tableTitle) {
    t11 = <p className="mb-2 text-xs font-medium text-gray-700">{p.tableTitle}</p>;
    $[21] = p.tableTitle;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== p.colTime) {
    t12 = <th className="pb-2 pr-2 font-medium">{p.colTime}</th>;
    $[23] = p.colTime;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== p.colEmployee) {
    t13 = <th className="pb-2 pr-2 font-medium">{p.colEmployee}</th>;
    $[25] = p.colEmployee;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== p.colEvent) {
    t14 = <th className="pb-2 pr-2 font-medium">{p.colEvent}</th>;
    $[27] = p.colEvent;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== p.colLocation) {
    t15 = <th className="pb-2 font-medium">{p.colLocation}</th>;
    $[29] = p.colLocation;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t12 || $[32] !== t13 || $[33] !== t14 || $[34] !== t15) {
    t16 = <thead><tr className="border-b border-gray-100 text-[10px] uppercase tracking-wide text-gray-400">{t12}{t13}{t14}{t15}</tr></thead>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== p.rows) {
    t17 = p.rows.map(_temp2);
    $[36] = p.rows;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t17) {
    t18 = <tbody>{t17}</tbody>;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t16 || $[41] !== t18) {
    t19 = <table className="w-full text-left text-xs">{t16}{t18}</table>;
    $[40] = t16;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== p.ctaHint) {
    t20 = <p className="mt-3 text-center text-[11px] text-gray-400 transition-colors group-hover:text-blue-600">{p.ctaHint}</p>;
    $[43] = p.ctaHint;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t11 || $[46] !== t19 || $[47] !== t20) {
    t21 = <div className="px-4 py-3 sm:px-5">{t11}{t19}{t20}</div>;
    $[45] = t11;
    $[46] = t19;
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t10 || $[50] !== t21 || $[51] !== t8) {
    t22 = <div className="-m-4 overflow-hidden rounded-b-2xl bg-white text-gray-900 ring-1 ring-black/5">{t8}{t10}{t21}</div>;
    $[49] = t10;
    $[50] = t21;
    $[51] = t8;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== p.windowTitle || $[54] !== t22) {
    t23 = <DashboardChrome title={t2}>{t22}</DashboardChrome>;
    $[53] = p.windowTitle;
    $[54] = t22;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== t0 || $[57] !== t1 || $[58] !== t23) {
    t24 = <Link href="#product" className="group block rounded-2xl transition-opacity hover:opacity-[0.98]"><motion.div whileHover={t0} transition={t1}>{t23}</motion.div></Link>;
    $[56] = t0;
    $[57] = t1;
    $[58] = t23;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  return t24;
}
function _temp2(row, index) {
  return <tr key={row.key} className={cn("border-b border-gray-50 text-gray-800", index === 0 && "animate-attendance-row-pulse")}><td className="py-2.5 pr-2 whitespace-nowrap text-gray-500">{row.time}</td><td className="py-2.5 pr-2 font-medium">{row.name}</td><td className="py-2.5 pr-2"><Badge variant="outline" className={cn("px-1.5 py-0 text-[10px]", getZkEventTypeBadgeClassName(row.eventType))}>{row.eventLabel}</Badge></td><td className="py-2.5 text-gray-600">{row.location}</td></tr>;
}
function _temp(m) {
  return <div key={m.label} className="rounded-lg border border-gray-100 bg-gray-50/80 px-2.5 py-2"><p className="text-[10px] text-gray-500">{m.label}</p><p className={cn("mt-0.5 text-base font-semibold tabular-nums", m.variant === "success" && "text-green-700", m.variant === "info" && "text-blue-700", m.variant === "neutral" && "text-gray-900")}>{m.value}</p></div>;
}